// extracted by mini-css-extract-plugin
export var displayNone = "_s7-6";
export var imgContainer = "_s7-2";
export var overflowHidden = "_s7-3";
export var productInfoCardButtonContainer = "_s7-5";
export var productTitleText = "_s7-4";
export var rightArrow = "_s7-1";
export var rightArrowContainer = "_s7-0";